import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0","key":"svg-0"}],["path",{"d":"M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4","key":"svg-1"}],["path",{"d":"M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2","key":"svg-2"}]]

const IconRoute2 = createReactComponent('outline', 'route-2', 'Route2', __iconNode);

export default IconRoute2;